import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Discover from "./views/Discover.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/About",
      name: "About",
      component: About
    },
    {
      path: "/Discover",
      name: "Discover",
      component: Discover
    }
  ]
});
